<template>
  <div class="message-container d-flex justify-content-end mb-2 outbound">
    <div class="d-flex align-items-center" v-if="isSpecialMessage">
      <el-tooltip effect="light" placement="left" content="Email group message" v-if="isEmailGroupMessage">
        <i class="fas fa-users mr-1"></i>
      </el-tooltip>
    </div>
    <div class="message">
      <div class="header text-right font-weight-bold">
        <span class="outgoing-number-title" v-if="getEmailAddressTitle">{{ getEmailAddressTitle | uppercase }}</span>
        <span class="outgoing-number-phone-number">{{ getEmailAddress | uppercase }}</span>
      </div>
      <div class="content d-flex flex-column" :style="styles">
        <div class="content-body w-100 d-flex flex-column">
          <div class="message-subject w-100 cursor-pointer" @click.prevent="onShowBody">
              <span style="font-size: 24px; vertical-align: middle;" class="mr-2">
                <i class="fas fa-envelope"></i>
              </span>
            <b>Subject:</b> {{ getSubject }}
            <i class="fas ml-2 mr-1" v-bind:class="[showBody ? 'fa-chevron-up' : 'fa-chevron-down']"></i>
          </div>
          <event-list :items="getEvents"></event-list>
          <div class="w-100 mt-2" v-if="showBody">
            <iframe-loader :url="getPreviewUrl"></iframe-loader>
          </div>
        </div>
      </div>
      <div class="footer text-right" :class="statusClasses">
        {{ statusString | uppercase }}
      </div>
    </div>
    <div class="logo ml-1">
      <el-image
          :src="logo"
          class="avatar"
          fit="contain"
      ></el-image>
    </div>
  </div>
</template>

<script>
import ChatMailMessage from "./chat-mail-message";
import EventList from "../events/list";
import IframeLoader from "../../iframe-loader";

export default {
  extends: ChatMailMessage,

  components: {
    EventList,
    IframeLoader,
  },

  computed: {
    /**
     * @return {String}
     */
    getEmailAddressTitle() {
      return _.get(this.emailAddress, 'title');
    },

    /**
     * @return {String}
     */
    getEmailAddress() {
      return _.get(this.emailAddress, 'address');
    },

    /**
     * @return {String}
     */
    logo() {
      return _.get(this.brand, 'logo');
    },

    /**
     * @return {String}
     */
    statusString() {
      switch (_.get(this.message, 'email_message.status')) {
        case 1:
        case 2:
          return 'sending ...';
        case 3:
          return 'message sent: ' + (this.formatTime(this.messageSentAt) || '');
        case 4:
          return 'sending error';
        default:
          return '';
      }
    },

    /**
     * @return {Array}
     */
    statusClasses() {
      return _.get(this.message, 'status') === 4
          ? ['text-warning', 'font-weight-bold']
          : ['text-black-50'];
    },

    /**
     * @return {String|null}
     */
    messageSentAt() {
      return _.get(this.message, 'sent_at', null);
    },

    /**
     * @return {Object}
     */
    styles() {
      const {
        'brand.item.text.color': color,
        'brand.item.background.color': backgroundColor
      } = _.get(this.brand, 'styles') || {};

      // remove empty values
      return _.pickBy({color, backgroundColor}, _.identity);
    },

    /**
     * @return {Boolean}
     */
    isSpecialMessage() {
      return this.isEmailGroupMessage;
    },

    /**
     * @return {Boolean}
     */
    isEmailGroupMessage() {
      return Boolean(this.emailMessage.email_bulk_message_id);
    },

    /**
     * @return {Array}
     */
    getEvents() {
      return _.get(this.emailMessage, 'events');
    },
  },
}
</script>

<style scoped>

</style>
